export default "__VITE_ASSET__CDqu2ccV__"